<ng-container *ngIf="sales">
  <div class="row content_display dashboard overallcontainer new-container" *transloco="let t;">
   <paypal-modal [visible]="showStripeModal" [purchaseContext]="purchaseContext" (isVisible)="showStripeModal=$event" (successTx)="paypalCallback($event)"></paypal-modal>
    <!-- -->
    <!--<div class="button-gradient" (click)="authorizePaymentToken()" *ngIf="!isLoadingAuthorize && !authorized && !ended">
      Authorize {{purchaseTokenName}}
  </div>
  <div class="button-gradient" *ngIf="isLoadingAuthorize && !authorized && !ended">
      <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
  </div>
</div>-->
    <div class="row content_display dashboard sale-block" *ngIf="salesInternal!==undefined">
      <div class="col" *ngFor="let sale of salesInternal; let i = index">
        <div class="card" [ngClass]="{'disabled': getDisabledMessage(sale.id) != ''}">
          <div class="card-content">
            <div class="rare-supply-ribbon">
              <span *ngIf="i==0">Rare NFT - 10K Max Supply</span>
              <span *ngIf="i==1">Rare NFT - 5K Max Supply</span>
            </div>
            <img class="sale-img" src="./assets/img/sales/{{sale.image}}" />
            <!-- <img class="sale-off" src="./assets/img/sales/Off.png" /> -->
            <p class="card-price">
              <!--<img src="./assets/img/Icon/Cur-USDT.png" />-->
              <span *ngIf="i==0">${{sale.price.toLocaleString()}} | 1.5K KMON | 8,740M Baby Doge </span>
              <span *ngIf="i==1">${{sale.price.toLocaleString()}} | 3.9K KMON | 21,921M Baby Doge </span>
              <!--<span class="card-price-devider" *ngIf="!canBuyKmon"></span><span *ngIf="!canBuyKmon">${{+this.totalAmounts[sale.id].toFixed(2)}}</span> -->
            </p>
          </div>
        </div>
        <k-dropdown-button class="mb-2" (onItemClick)="buyGate($event, sale.id)" [menuItems]="buyMethods" [label]="t('shared.buyNow')" *ngIf="buyMethods.length>0 && (getDisabledMessage(sale.id)) == '' && !isLoadingBuy"></k-dropdown-button>
        <div class="button-gradient"
          *ngIf="(getDisabledMessage(sale.id) == '') && isLoadingBuy">
          <fa-icon [icon]="['fas', 'spinner']" class="fa-spin"></fa-icon>
        </div>
        <div class="button-outline" *ngIf="getDisabledMessage(sale.id).startsWith('Starting')">
          {{getDisabledMessage(sale.id)}}
    </div>
      </div>
      <!--<div class="button-outline" *ngIf="(getDisabledMessage(sale.id) == '' || getDisabledMessage(sale.id).startsWith('Not enough')) && !isLoadingBuy && !isLonger" (click)="startPurchase(sale.id)">
      Buy with Credit Card
    </div>-->
     <!-- <div class="button-gradient"
          *ngIf="(getDisabledMessage(sale.id) == '' || getDisabledMessage(sale.id).startsWith('Not enough')) && isLoadingBuy && !isLonger">
          <fa-icon [icon]="['fas', 'spinner']" class="fa-spin"></fa-icon>
        </div>-->
       <!-- </div>
        <p style="text-align:center"
          *ngIf="(getDisabledMessage(sale.id)  == '' || getDisabledMessage(sale.id).startsWith('Not enough')) && isLonger">
          Waiting for BNBs to arrive, you'll receive an email and then you can move forward
        </p>
        <div class="button-gradient disabled"
          *ngIf="getDisabledMessage(sale.id) != '' && !getDisabledMessage(sale.id).startsWith('Not enough')">
          {{getDisabledMessage(sale.id)}}
        </div>-->
      <!--<div class="button-outline" (click)="openPancake()" *ngIf="getDisabledMessage(sale.id).startsWith('Not enough')">
      Get {{purchaseTokenName}}
    </div>-->
    </div>
    <div class="baby-doge-holder-container">
      <div class="baby-doge-holder-text">
        <span>Holding Baby Doge ? Redeem now your free Baby Doge head NON-NFT cosmetic.</span>
      </div>
      <div class="card" [ngClass]="{'disabled': babyDogeBalance<1 || !canClaimCosmetic || forceClosed}">
          <div class="card-content">
            <div class="rare-supply-ribbon">
              <span>Claim will open on the 25th of January @12pm UTC</span>
            </div>
            <img class="sale-img" src="./assets/img/sales/babydoge_head.png" />
            <!-- <img class="sale-off" src="./assets/img/sales/Off.png" /> -->
            <p class="card-price">
              <!--<img src="./assets/img/Icon/Cur-USDT.png" />-->
              <k-button buttonStyle="gradient" [label]="'Claim'" *ngIf="babyDogeBalance>=1 && canClaimCosmetic && !forceClosed" (click)="claimFreeCosmetic()"></k-button>
              <!--<span class="card-price-devider" *ngIf="!canBuyKmon"></span><span *ngIf="!canBuyKmon">${{+this.totalAmounts[sale.id].toFixed(2)}}</span> -->
            </p>
          </div>
        </div>
    </div>
  </div>
  <div class="refill-wallet-section" *ngIf="parsedBoxes">
    <h3>Refill your wallet with KMON</h3>
    <div class="boxes-container">
      <div class="boxes-list" *ngIf=" !isLonger">
        <div class="boxes-item" *ngFor="let pb of purchaseBoxes; let i = index" [ngClass]="{'selected':boxSelected[i],'shrink': (boxSelected[0] || boxSelected[1] || boxSelected[2] || boxSelected[3])}">
          <div class="box-img">
            <img class="img-coin" src="{{pb.img}}" />
          </div>
          <div class="box-content">
            <div class="golden-tag">{{pb.kmonAmountFormatted}}</div>
            <span>KMON<br>Package</span>
            <div class="box-bottom">
              <div class="price-item">
                <p class="usd-value">${{pb.totalValue}}</p>
              </div>
              <div class="box-detail">
                <p class="kmon-bnb"><img src="./assets/img/Home/k-logo.png" />{{pb.kmonAmountFormatted}}</p>
                <div class="divider"></div>
                <p class="kmon-bnb"><img src="./assets/img/Icon/Cur-BNB.png" />{{pb.bnbAmount}}</p>
              </div>
              <!---->
            </div>
          </div>
          <div class="actions-overlay" [ngClass]="{'forceShow': isSimplexLoading[i] || isSimplexSuccess[i]}">
            <div class="actions">
              <div class="button-gradient" (click)="initPurchase(i)" *ngIf="!isSimplexLoading[i] && !isSimplexSuccess[i]">Buy</div>
              <div class="button-gradient" *ngIf="isSimplexLoading[i]">
                <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
              </div>
              <div class="button-gradient" *ngIf="isSimplexSuccess[i]">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="is-longer" *ngIf="isLonger">
        <h1>Koagea Connection Latency...</h1>
        <p>Looks like the BNB will require a bit more time to arrive, this can be due to a latency on the blockchain
          or,
          in case you have been asked to provide your ID, due to ID check. You'll receive an email as soon as your BNB
          will be sent to your wallet, so then you'll be able to come back here and get your KMONs</p>
        <h1>In case you will not receive any email from Simplex in an hour or so, feel free to contact us!</h1>
      </div>
    </div>
  </div>
  <div class="overlay" *ngIf="showOnramper" (click)="closeOnramper()">
    <iframe style="border-radius: 4px; border: 1px solid #58585f; margin: auto;max-width: 420px" [src]="srcOnramper" height="630px" width="420px" title="Onramper widget" allow="accelerometer; autoplay; camera; gyroscope; payment" class="iframe-onramper">
    </iframe>
    <!-- <div class="onramper-close-button">
      <div class="button-outline" (click)="showOnramper = false">Cancel</div>
    </div> -->
  </div>
  <div class="simplexWidget" [ngClass]="{'show': showWidget}" *ngIf="!waitingForFunds">
    <form id="simplex-form">
      <div id="checkout-element">
        <!-- checkout will be rendered here -->
      </div>
    </form>
    <div class="buttons">
      <div class="button-outline" (click)="closeSimplex()">Cancel</div>
    </div>
  </div>
</ng-container>
